import { render, staticRenderFns } from "./V2StoreCart.vue?vue&type=template&id=072b2cef&scoped=true&"
import script from "./V2StoreCart.vue?vue&type=script&lang=js&"
export * from "./V2StoreCart.vue?vue&type=script&lang=js&"
import style0 from "./V2StoreCart.vue?vue&type=style&index=0&id=072b2cef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072b2cef",
  null
  
)

export default component.exports